import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7d697e4b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "ojJudgeCaseModal" }

import { ref } from "vue";
import message from "@arco-design/web-vue/es/message";
import { IconPlus, IconEdit, IconDelete } from "@arco-design/web-vue/es/icon";
import API from "@/api";
import {
  deleteOjJudgecaseUsingPost,
  getOjJudgecaseListUsingPost,
} from "@/api/ojJudgecaseController";
import AddOjJudgeCaseModal from "@/views/oj/components/AddOjJudgeCaseModal.vue";

/**
 * 定义组件属性类型
 */
interface Props {
  id: string;
}

/**
 * 给组件指定初始值
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'OjJudgeCaseModal',
  props: {
    id: { default: () => "" }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const visible = ref(false);
const openModal = () => {
  loadData();
  visible.value = true;
};

const closeModal = () => {
  visible.value = false;
};

__expose({
  openModal,
});

const tableColumns = [
  {
    title: "输入",
    dataIndex: "input",
    align: "center",
  },
  {
    title: "输出",
    dataIndex: "output",
    align: "center",
  },
  {
    title: "操作",
    slotName: "optional",
    align: "center",
  },
];

const tableData = ref<API.OjJudgecaseVO[]>();
// 初始化搜索条件
const initSearchParams = {
  current: 1,
  pageSize: 10,
};
const searchParams = ref<API.OjJudgecaseQueryRequest>({
  ...initSearchParams,
});
const total = ref<number>(0);

const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
  loadData();
};
/**
 * 加载数据
 */
const loadData = async () => {
  if (!props.id) {
    return;
  }
  const res = await getOjJudgecaseListUsingPost({
    ...searchParams.value,
    questionId: props.id as any,
  });
  if (res.data.code === 200 && res.data.data) {
    tableData.value = (res.data.data.records as any) || [];
    total.value = res.data.data.total || 0;
  } else {
    message.error("获取数据失败，" + res.data.message);
  }
};

const addOjJudgeCaseModalRef = ref();
const openAddOjJudgeCaseModal = (id: any) => {
  addOjJudgeCaseModalRef.value.openModal(id);
};

const handleDelete = async (id: any) => {
  const res = await deleteOjJudgecaseUsingPost({
    id,
  });
  if (res.data.code === 200 && res.data.data) {
    message.success("删除成功");
  } else {
    message.error("删除失败，" + res.data.message);
  }
  loadData();
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
      onCancel: closeModal,
      footer: false,
      fullscreen: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openAddOjJudgeCaseModal('')))
        }, {
          icon: _withCtx(() => [
            _createVNode(_unref(IconPlus))
          ]),
          default: _withCtx(() => [
            _createTextVNode(" 添加用例 ")
          ]),
          _: 1
        }),
        _createVNode(_component_a_table, {
          columns: tableColumns as any,
          data: tableData.value,
          pagination: {
          showTotal: true,
          pageSize: searchParams.value.pageSize,
          current: searchParams.value.current,
          total: total.value,
        },
          onPageChange: onPageChange
        }, {
          optional: _withCtx(({ record }) => [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: ($event: any) => (openAddOjJudgeCaseModal(record.id))
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(IconEdit))
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_a_button, {
              status: "danger",
              onClick: ($event: any) => (handleDelete(record.id))
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(IconDelete))
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["columns", "data", "pagination"]),
        _createVNode(AddOjJudgeCaseModal, {
          ref_key: "addOjJudgeCaseModalRef",
          ref: addOjJudgeCaseModalRef,
          "question-id": _ctx.id,
          onUpdateData: loadData
        }, null, 8, ["question-id"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})